/* eslint-disable no-console */

import { register } from 'register-service-worker'
import { isOfflineSimulated, setOfflineSimulated } from '@/helpers/offline-simulation'
import eventBus from '@/helpers/event-bus'

// اسم مختلف أثناء التطوير (dev-service-worker.js) لتفادي الـ noop middleware
// الذي يعترض دائماً الطلبات إلى '/service-worker.js' في vue-cli-service serve
const swFileName = process.env.NODE_ENV === 'production' ? 'service-worker.js' : 'dev-service-worker.js'

// الـ service worker لا يحتفظ بحالة محاكاة عدم الاتصال بنفسه (لا يصل إلى localStorage)،
// لذا نُعيد إرسالها إليه كلما تغيّر الـ controller النشط (تحميل أول، أو تحديث لاحق)
if ('serviceWorker' in navigator) {
	navigator.serviceWorker.addEventListener('controllerchange', () => {
		setOfflineSimulated(isOfflineSimulated())
	})
}

register(`${process.env.BASE_URL}${swFileName}`, {
	ready () {
		console.log(
			'App is being served from cache by a service worker.\n' +
			'For more details, visit https://goo.gl/AFskqB'
		)
	},
	registered () {
		console.log('Service worker has been registered.')
	},
	cached () {
		console.log('Content has been cached for offline use.')
	},
	updatefound () {
		console.log('New content is downloading.')
	},
	updated () {
		console.log('New content is available; please refresh.')
		// الـ service worker يستدعي self.skipWaiting()/clients.claim() تلقائياً عند التثبيت، فالإصدار
		// الجديد يتحكم بالطلبات فوراً - يبقى فقط أن يُعاد تحميل الصفحة لتحميل الحزمة الجديدة فعلياً،
		// ونترك ذلك لاختيار المستخدم (عبر هذا الحدث) تفادياً لضياع بيانات مسودة الزيارة غير المحفوظة
		eventBus.$emit('app-update-available')
	},
	offline () {
		console.log('No internet connection found. App is running in offline mode.')
	},
	error (error) {
		console.error('Error during service worker registration:', error)
	}
})
